import { serialize } from 'utils/utils';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  HOTEL_DETAILS_REQUEST: 'HOTEL_DETAILS_REQUEST',
  HOTEL_DETAILS_SUCCESS: 'HOTEL_DETAILS_SUCCESS',
  HOTEL_DETAILS_FAILURE: 'HOTEL_DETAILS_FAILURE',
  HOTEL_DETAILS_SET_LOADING_STATE: 'HOTEL_DETAILS_SET_LOADING_STATE',
  RESORT_GUIDE_REQUEST: 'RESORT_GUIDE_REQUEST',
  RESORT_GUIDE_SUCCESS: 'RESORT_GUIDE_SUCCESS',
  RESORT_GUIDE_FAILURE: 'RESORT_GUIDE_FAILURE',
  ROOM_OPTIONS_SUCCESS: 'ROOM_OPTIONS_SUCCESS',
  RESET_HOTEL_DETAILS: 'RESET_HOTEL_DETAILS',
};

export const setHotelDetails = data => ({
  type: TYPES.HOTEL_DETAILS_SUCCESS,
  response: data,
});

export const setLoadingState = data => ({
  type: TYPES.HOTEL_DETAILS_SET_LOADING_STATE,
  data,
});

export const loadHotelDetails = config => (dispatch, getState) => {
  const pageStart = getState().baseState ? getState().baseState.get('pageStart', 0) : 0;
  const defaultParams = {
    results: 1,
    url: '',
    pageStart,
  };

  const params = Object.assign(defaultParams, config);

  if (!params.state) {
    params.state = '';
  }

  return dispatch({
    [CALL_API]: {
      types: [
        TYPES.HOTEL_DETAILS_REQUEST,
        TYPES.HOTEL_DETAILS_SUCCESS,
        TYPES.HOTEL_DETAILS_FAILURE,
      ],
      schema: Schemas.HOTEL_DETAILS,
      endpoint: `/bridge/?${serialize(params)}`,
    },
  });
};

export const resetHotelDetails = () => ({
  type: TYPES.RESET_HOTEL_DETAILS,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/hotelDetailsActions.js
 **/